import Auth from "@/services/auth";

const IfAuth = (to,from,next) => {
  if(Auth.loggedIn()){
    if(to.query.token != undefined){
      window.localStorage.clear();
      return next({
        path: '/login?token='+to.query.token
      })
    }else{
      return next({
        path: '/dashboard'
      })
    }
  }
  return next();
}

export default IfAuth;
